<h1 class="u-sr-only">{{ 'Training.Menu.Programs' | translate }}</h1>
<section class="c-section c-section--last u-no-pb" panel [isOpen]="true">
    <div class="c-section__header">
        <p class="c-section__title u-hidden@md-and-up">{{ 'Training.Create.Title' | translate }}</p>
    </div>
    <div class="c-section__content">
        <div class="o-grid">
            <div class="o-grid__cell c-cell">
                <card-employee-training-program [trainingProgramCode]="vm.trainingProgramCode"></card-employee-training-program>
            </div>
        </div>
    </div>
</section>
